import { Modality } from 'types';
import {
  ModalityExtension,
  OfferingTypeConfig,
  OfferingTypes,
} from '../utils/types';
import compReviewConfig from './compReview';
import courseConfig from './course';
import earlyAccessConfig from './earlyAccess';
import examConfig from './exam';
import examExperienceConfig from './examExperience';
import expertSeminarConfig from './expertSeminar';
import labPlusConfig from './labPlus';
import lessonConfig from './lesson';
import livePremiumSessionCourseConfig from './livePremiumSessionCourse';
import liveVirtualClassConfig from './liveVirtualClass';
import premiumSessionConfig from './premiumSession';
import skillsPathConfig from './skillsPath';
import techOverviewConfig from './techOverview';
import liveEventsConfig from './liveEvents';
import skillsAssessmentConfig from './skillsAssessment';

const offeringTypeRegistry: Partial<Record<OfferingTypes, OfferingTypeConfig>> =
  {
    [Modality.Course]: courseConfig,
    [Modality.Exam]: examConfig,
    [Modality.ExpertSeminar]: expertSeminarConfig,
    [Modality.TechOverview]: techOverviewConfig,
    [ModalityExtension.CompReview]: compReviewConfig,
    [ModalityExtension.EarlyAccess]: earlyAccessConfig,
    [ModalityExtension.ExamExperience]: examExperienceConfig,
    [ModalityExtension.LabPlus]: labPlusConfig,
    [ModalityExtension.Lesson]: lessonConfig,
    [ModalityExtension.LiveEvents]: liveEventsConfig,
    [ModalityExtension.LivePremiumSessionCourse]:
      livePremiumSessionCourseConfig,
    [ModalityExtension.LiveVirtualClass]: liveVirtualClassConfig,
    [ModalityExtension.PremiumSession]: premiumSessionConfig,
    [ModalityExtension.SkillsPath]: skillsPathConfig,
    [ModalityExtension.SkillsAssessment]: skillsAssessmentConfig,
  };

export default offeringTypeRegistry;
